<template>
  <div class="f-aboutUsModal">
    <b-modal id="aboutUsModal"
             ref="aboutUsModal"
             centered
             size="lg"
             title="AlpFoodwayUNESCO">
      <p class="my-4 citation" id="captionText">"Foodways are socioeconomic and cultural practices related to food production and consumption. Food heritage is a strong identity source for alpine populations. It goes beyond products to include productive landscapes and traditional knowledge on production techniques, consumption customs and rituals, and the transmission of ancient wisdom."
      </p>

      <div slot="modal-footer" class="w-100">
        <!--<b-button class="button-style float-left" @click="expandModal">{{activeLanguage.readMore}}</b-button>-->
        <a href="http://www.alpine-space.eu/projects/alpfoodway/en/about/the-project/aims-activities" target="_blank"><b-button class="button-style">{{activeLanguage.readMore}}</b-button></a>
      </div>
    </b-modal>
  </div>
</template>

<script>
    export default {
      name: 'AboutUsModal',
      computed: {
        activeLanguage () {
          return this.$translations[this.$store.getters.currentLanguageValue]
        }
      },
      methods: {
        showModal () {
          this.$refs.aboutUsModal.show()
        },
        hideModal () {
          this.$refs.aboutUsModal.hide()
        },
        expandModal () {
          document.getElementById('captionText').innerHTML += '"Depopulation, ageing population and globalization put Alpine food heritage at risk of disappearing. The project will create a sustainable development model for peripheral mountain areas based on the preservation/valorization of Alpine Space cultural food heritage and on the adoption of innovative marketing and governance tools. It will also foster the emerging of a transnational alpine identity based on the common cultural values expressed in food heritage. Project outputs include Vision Paper, Value Charta, mapping of traditional food heritage, creation of a cutting edge online inventory, courses and educational units, and a cultural exchange platform based on events and tourist tours. The project will benefit heritage communities; local development professionals and organizations; cultural institutions; local, regional and national authorities. The project is innovative since it links food heritage with marketing and consumer culture, and does not consider heritage communities as passive recipients of ‘top-down’ interventions, but instead supports ‘bottom-up’ mobilization processes based on engagement/empowerment of the citizenship. The project also contributes to a recent international debate (the 2003 UNESCO Convention) on the Intangible Cultural Heritage. All Alpine administrations are experimenting safeguard and valorization solutions – albeit in a fragmented and uncoordinated way. The project will develop this theme at a scale – the entire Alps – never attempted before. As future perspective, the Alpine community could aspire to inscribe the Alpine food heritage on the UNESCO intangible cultural heritage list as a traditional foodway.\n' +
            '\n' +
            'The project contributes to Priority 3 (Liveable Alpine Space) as it valorizes Alpine Space cultural/natural heritage and enhances protection and conservation of the Alpine Space. "'
        }
      },
      mounted () {
        document.getElementById('aboutUsModal___BV_modal_header_').setAttribute('style', 'background-color: #c41c21 !important; color: white !important;')
        document.getElementById('aboutUsModal___BV_modal_header_').lastChild.setAttribute('style', 'color: white !important;')
      }
    }
</script>

<style scoped>

  .button-style {
    background-color: #c41c21 !important;
    border-color: #c41c21 !important;
  }

  .citation {
    font-style: italic;
    font-variant: petite-caps;
    font-size: 1.2em;
    font-weight: 500;
  }

</style>



// WEBPACK FOOTER //
// src/components/pagesComponents/homePageComponents/AboutUsModal.vue